import { z } from 'zod';
export const offsetPaginationSchema = z.object({
    total: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
    offset: z.number().int().nonnegative(),
    hasMore: z.boolean(),
});
/** List pagination with API max page size (players/teams endpoints). */
export const offsetPaginationWithMaxLimitSchema = offsetPaginationSchema.extend({
    limit: z.number().int().positive().max(100),
});
export const simpleOffsetPaginationSchema = z.object({
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
    total: z.number().int().nonnegative().optional(),
});
